import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import useGlobalModel from "@/erp_subpackage/model/globalModel";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useVehicleModel } from "../vehicleModel";
export function PageHeader() {
    const { t } = useTranslation();
    const { searchParam, organType, loadData, updateSearchParam, resetSearchParam } = useVehicleModel()
    const { orgDs } = useGlobalModel(({ orgDs }) => [orgDs]);
    const searchFields = [
        ...(organType ? [{
            type: "Select",
            placeholder: t(`base.view.PageHeader.所属机构`),
            fieldName: "shopId",
            options: orgDs
        }] : []),
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.客户名称`),
            fieldName: "customerName",
        },
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.车辆牌照`),
            fieldName: "licensePlate",
        },
        {
            type: "Input",
            placeholder: `vin${t(`base.view.PageHeader.码`)}`,
            fieldName: "vin",
        },
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.发动机号`),
            fieldName: "engineCode",
        },
        {
            type: "Datepicker",
            placeholder: t(`base.view.PageHeader.登记日期`),
            fieldName: "createTime",
        },
    ]

    return (
        <YhPageHeader
            title= {t(`base.view.PageHeader.车辆管理`)}
            size="small"
            triggerSearch={true}
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { loadData({ pageNum: 1 }, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    )
}
